<template>
    <div class="login-page">
        <div class="wrapper wrapper-full-page">
            <div class="full-page login-page section-image">
                <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
                <div class="content">
                    <div class="container">
                        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                            <card type="login">
                                <h5 slot="header" class="header text-center">Reset Password</h5>
                                <div v-if="success" class="alert alert-success" role="alert">
                                    <h5 class="alert-heading">Email Sent!</h5>
                                    If you do not see an email from us, please check your junk folder or try again.
                                </div>
                                <p>We will send you an email with instructions on how to reset your password!</p>
                                <form @submit.prevent="submitForgotPassword">
                                    <fg-input
                                        v-model="form.email"
                                        v-validate="modelValidations.email"
                                        :error="getError('email')"
                                        name="email"
                                        addon-left-icon="nc-icon nc-single-02"
                                        placeholder="Email"
                                        type="email"
                                    >
                                    </fg-input>

                                    <p-button slot="footer" :disabled="loading" nativeType="submit" type="success" block class="mb-3">
                                        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                                        {{ loading ? null : 'Submit' }}
                                    </p-button>
                                    <p v-if="error" class="text-danger">
                                        <strong>{{ error }}</strong>
                                    </p>
                                    <router-link :to="{ path: '/login' }">Back to Login</router-link>
                                </form>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getError } from '@/utils/validateErrors'
import { Card, Button } from '@/components/UIComponents'
export default {
    components: {
        Card,
        [Button.name]: Button
    },
    data() {
        return {
            form: {
                email: '',
                success: false
            },
            modelValidations: {
                email: {
                    required: true
                }
            },
            loading: false,
            success: false,
            error: false
        }
    },
    beforeDestroy() {
        this.closeMenu()
    },
    methods: {
        getError,
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        async submitForgotPassword() {
            const isValid = await this.$validator.validateAll()
            if (isValid) {
                const values = {
                    email: this.form.email
                }
                this.success = false
                this.loading = true
                this.error = false
                try {
                    await this.$store.dispatch('auth/FORGOT_PASSWORD', values)
                    this.success = true
                } catch (err) {
                    this.error = ((code) => {
                        switch (code) {
                            case 'auth/invalid-email':
                                return 'Invalid email'
                            case 'auth/user-not-found':
                                return 'An account with that email does not exist'
                            case 'auth/user-disabled':
                                return 'This account has been disabled'
                            case 'auth/unauthorized':
                                return 'This account is unauthorized'
                            default:
                                return 'Invalid login'
                        }
                    })(err.code)
                } finally {
                    this.loading = false
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.full-page > .content {
    padding-top: 4rem;
    margin-bottom: 6rem;
}
</style>
